const kuperShiftsGroups = {
    colsOrder: ['name', 'count'],
    cols: {
        name: {
            content: 'Название',
            width: 80,
            isAdminMain: true,
        },
        count: { content: 'Импортировано', width: 20 },
    },
    adminIndex: 0,
    deletesCols: [],
    url: 'kuperShiftGroup',
    emptyInfo: {
        title: 'Реестров пока нет',
        description: 'Вы можете загрузить реестр по кнопке справа',
    },
} as const;

export default kuperShiftsGroups;
